import React, { memo, useEffect, useRef, useState } from 'react';
import { CustomPromotionVoucher } from 'types/Product';
import styled from 'styled-components';
import CustomVoucherCard from './Card/CustomVoucherCard';
import CustomVoucherDialog from './Dialog/CustomVoucherDialog';

export interface CustomPromotionContainerProps {
  promotionVoucher: CustomPromotionVoucher;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomPromotionComponent = memo((props: CustomPromotionContainerProps) => {
  const { promotionVoucher } = props;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRendered, setDialogRendered] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (dialogRendered) {
      setDialogOpen(true);
    }
  }, [dialogRendered]);

  const openDialog = () => {
    if (dialogRendered) {
      setDialogOpen(true);
    } else {
      setDialogRendered(true);
    }
  };

  const closeDialog = () => setDialogOpen(false);
  const handleClose = () => setDialogOpen(false);

  return (
    <Container>
      <CustomVoucherCard promotionVoucher={promotionVoucher} openDialog={openDialog} />
      {dialogRendered && (
        <CustomVoucherDialog
          promotionVoucher={promotionVoucher}
          dialogOpen={dialogOpen}
          closeDialog={closeDialog}
          handleClose={handleClose}
        />
      )}
    </Container>
  );
});

export default CustomPromotionComponent;
